import { Injectable } from '@angular/core';
import { APICoreService } from '../../../../common/services/api-core/api-core.service';
import { NotificationType } from '../../dtos/notifications.dto';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(private apiService: APICoreService) {}

  getNotifications(
    unread = true,
    notificationType?: NotificationType,
    params: Record<string, unknown> = {}
  ) {
    const path = unread
      ? 'growelab/notifications/unread'
      : 'growelab/notifications';
    return this.apiService.getRequest(path, {
      ...params,
      notification_type: notificationType,
    });
  }

  markNotificationAsRead(notificationIds: number[]) {
    return this.apiService.putRequest('growelab/notifications/read', {
      id: notificationIds,
    });
  }
}
